import {GetStaticProps} from "next";
import {MarkdownMetaDataInterface} from "../interfaces/MarkdownMetaDataInterface";
import {getStaticPropsForMarkdownPageCategory} from "../helpers/GetStaticPropsForMarkdownPage";
import Image from "next/image";
import HeaderImageWithHeading from "../components/common/HeaderImageWithHeading";
import {HeaderImages} from "../data/StaticImages";
import SimpleMarkdownRenderer from "../components/common/SimpleMarkdownRenderer";
import {MarkdownContent} from "../markdown/MarkdownContent";
import Button from "../components/common/Button";
import {useTranslation} from "next-i18next";
import {getSafeLocale} from "../helpers/LocalizeObject";

function Page({
	              metadatas,
	              markdowns: MDXFiles,
	              paths
              }: {
	metadatas: MarkdownMetaDataInterface[];
	markdowns: any[];
	paths: string[];
}) {
	const {t} = useTranslation();
	return (
		<>
			<HeaderImageWithHeading
				title={t("pages.leistungen.heading")}
				imageSrc={HeaderImages[3]}
			/>
			<div className="container px-6 mx-auto my-20 flex flex-col gap-y-20 divide-y-2 [&>*]:pt-20">
				{MDXFiles.map((MDXFile, idx) => (
					<div
						className={`flex flex-col xl:odd:flex-row md:even:flex-row-reverse gap-x-10 w-full`}
						key={idx}
					>
						<div className="flex-1 relative min-h-[300px] lg:min-h-[500px] shrink-0">
							<Image
								quality={90}
								src={metadatas[idx].metadata.metadata.image}
								alt={metadatas[idx].metadata.metadata.title}
								fill
								className="object-cover"
							/>
						</div>
						<div className="flex-1 items-center flex">
							<div className="xl:px-24">
								<SimpleMarkdownRenderer
									mdxFile={MDXFile}
									className="max-h-[300px] overflow-hidden after:absolute after:bottom-0 after:left-0 after:h-[100px] after:w-full after:bg-[linear-gradient(rgba(255,255,255,0.0),rgba(255,255,255,0.8),white)] relative"
									showMoreLink={paths[idx]}
								/>
							</div>
						</div>
					</div>
				))}
				<div
					className={`flex flex-col min-h-[800px] lg:h-full gap-10 lg:flex-row lg:items-center lg:gap-x-10 xl:w-full`}
				>
					<div className="flex-1 relative h-[300px] lg:h-[500px] shrink-0">
						<Image
							quality={90}
							src={"/stock_images/4.jpg"}
							alt={"Weitere Leistungen"}
							fill
							className="object-cover"
						/>
					</div>
					<div className="flex-1 items-start flex-col flex">
						<div className="lg:px-12 xl:px-24">
							<h3 className="mb-10">
								{t("pages.leistungen.weitereLeistungenHeading")}
							</h3>
							<p>{t("pages.leistungen.weitereLeistungenIntro")}</p>
							<Button
								text={"Mehr erfahren"}
								transparent={false}
								border={false}
								href={"/leistungen/weitere-leistungen"}
								className="mt-5 rounded-[10px]"
								minWidth="w-[200px]"
								padding={"px-6 py-[14px]"}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export const getStaticProps: GetStaticProps = async (context) => {
	return getStaticPropsForMarkdownPageCategory(getSafeLocale(context.locale)!, "leistungen");
};

export default Page;
